{
  "nl": {
    "form": {
      "actions": {
        "cancel": "Annuleren",
        "clear": "Wissen",
        "closeFullPage": "Volledige pagina sluiten",
        "copyText": "Klik om tekst te kopiëren",
        "create_and_send_to_customer": "Aanmaken en verzenden naar klant",
        "create_and_share": "Maak aan en deel met klant",
        "create_and_share_partners_only": "Maak aan en deel met partner(s)",
        "create_and_share_with_partners": "Maak aan en deel met klant en partner(s)",
        "next": "Volgende",
        "only_create": "Alleen aanmaken",
        "openFullPage": "Open in volledige pagina",
        "save": "Opslaan",
        "saveChanges": "Sla veranderingen op",
        "search": "Zoeken...",
        "send": "Verzenden",
        "send_and_create_another": "Verzenden en nog één maken",
        "send_to_customer": "Verzenden naar klant",
        "share_with_customer": "Delen met klant",
        "submit": "Opslaan",
        "submit_and_create_another": "Opslaan en nog één maken"
      },
      "back": "Vorige stap",
      "labels": {
        "columns": "Kolommen",
        "from": "Van",
        "no_results": "Geen resultaten",
        "optional": "(optioneel)",
        "to": "Tot"
      },
      "notifications": {
        "textHasBeenCopied": "   Tekst is gekopieerd"
      },
      "password": "Wachtwoord",
      "shortcuts": {
        "save_mac": "⌘ + Enter om op te slaan",
        "save_windows": "Ctrl + Enter om op te slaan",
        "send_mac": "⌘ + Enter om te verzenden",
        "send_windows": "Ctrl + Enter om te verzenden"
      },
      "steps": "Stap {count} van {total}",
      "writeEmployeeNameReject": "Schrijf <i><b>{employeeName}</b></i> neer om het verwijderen te bevestigen."
    }
  }
}
